import { Button, Card, Space, Typography } from 'antd';
import type { ReactNode } from 'react';

/**
 * An empty section (design §1.4): ONE line, ONE primary button, at most one link-style secondary (only where the card it replaced carried
 * an action). When this renders, the section does NOT mount its header Assign / create button — the primary here IS it, so
 * `tool-section-assign` exists once in the DOM.
 */
export type EmptyStateProps = {
  testId?: string;
  text: string;
  primary: ReactNode;
  secondary?: { label: string; onClick: () => void; testId: string };
};

export const EmptyState = ({
  testId = 'tool-section-empty',
  text,
  primary,
  secondary,
}: EmptyStateProps) => (
  <Card size="small" data-testid={testId}>
    <Space direction="vertical" size="small">
      <Typography.Text type="secondary">{text}</Typography.Text>
      <Space wrap>
        {primary}
        {secondary ? (
          <Button
            type="link"
            onClick={secondary.onClick}
            data-testid={secondary.testId}
          >
            {secondary.label}
          </Button>
        ) : null}
      </Space>
    </Space>
  </Card>
);
